import { Logger } from '../helpers/Logger';
import { AdapterConfig } from '../models/AdapterConfig';
import { Environment } from './Environment';

export class ServiceWorkerManager {
    static registration: ServiceWorkerRegistration | PromiseLike<ServiceWorkerRegistration | null> | null;

    static getServiceWorkerFullPath(config: AdapterConfig): string {
        return `/${config.getServiceWorkerName()}`;
    }

    static getNativeServiceWorker(): ServiceWorkerContainer {
        return navigator.serviceWorker;
    }

    static async register(config: AdapterConfig): Promise<ServiceWorkerRegistration | null> {
        let registration: ServiceWorkerRegistration | PromiseLike<ServiceWorkerRegistration | null> | null = null;

        if (!Environment.supportsServiceWorkers()) {
            return Promise.reject();
        }

        const serviceWorkerPath: string = ServiceWorkerManager.getServiceWorkerFullPath(config);
        Logger.info(`[Sidetalk][ServiceWorkerManager]: Installing service worker from ${serviceWorkerPath}.`);

        try {
            registration = await ServiceWorkerManager.getNativeServiceWorker().register(serviceWorkerPath, {
                updateViaCache: 'none',
            });
        } catch (error) {
            Logger.error(`[Sidetalk][ServiceWorkerManager]: Installing service worker failed ${error}`);
            throw error;
        }

        Logger.debug(`[Sidetalk][ServiceWorkerManager]: Service worker installed.`);

        return registration;
    }

    static async getRegistration(): Promise<ServiceWorkerRegistration | undefined> {
        return ServiceWorkerManager.getNativeServiceWorker().getRegistration();
    }

    static async waitForReady(): Promise<ServiceWorkerRegistration> {
        if (!Environment.supportsServiceWorkers()) {
            return Promise.reject();
        }

        return ServiceWorkerManager.getNativeServiceWorker().ready;
    }
}
